import type { AxiosError } from 'axios';
import axios from 'axios';

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { APIStatus } from '../../../enum';
import type { NameValue } from '../../../models/dashboard';
import type { ErrorMessage } from '../../../models/error';
import type { AsyncThunkConfig } from '../../../models/slice';
import { RaygunErrorHandlerService } from '../../../service/raygun.service';

const { logError } = RaygunErrorHandlerService();

export type PreferenceCount = {
  org_code: string;
  label_group_name: string;
  data: NameValue[];
};

export type DashboardData = {
  label_group_counts: NameValue[];
  guest_label_counts: NameValue[];
  preference_counts: PreferenceCount[];
};

type ProgramDashboardSliceType = {
  dashboardData: DashboardData;
  dashboardApiStatus: APIStatus;
};

const initialState: ProgramDashboardSliceType = {
  dashboardData: {
    label_group_counts: [],
    guest_label_counts: [],
    preference_counts: [],
  },
  dashboardApiStatus: APIStatus.IDLE,
};

export const loadDashboard = createAsyncThunk<DashboardData, undefined, AsyncThunkConfig>(
  'preferencesDashboard/loadDashboard',
  async (_, thunkAPI) => {
    try {
      const response = await axios.post('v0_preferences_dashboard', {});
      return response as unknown as DashboardData;
    } catch (e) {
      logError(e, ['preferencesDashboardSlice', 'loadDashboard']);
      return thunkAPI.rejectWithValue((e as AxiosError<ErrorMessage>).response?.data);
    }
  },
);

export const preferencesDashboardSlice = createSlice({
  name: 'preferencesDashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadDashboard.pending, (state, _action) => {
        state.dashboardApiStatus = APIStatus.PENDING;
      })
      .addCase(loadDashboard.fulfilled, (state, action) => {
        state.dashboardData = action.payload;
        state.dashboardApiStatus = APIStatus.FULFILLED;
      })
      .addCase(loadDashboard.rejected, (state, _action) => {
        state.dashboardApiStatus = APIStatus.ERROR;
      });
  },
});
